module.exports = __webpack_public_path__ + "media/assets/avia/ticket/plane-90d0b2dc4265723b6c301142a369c485.png";